import { ajax } from '../../../util' 
import { isLogin } from '../../../actions' 

function afterLogin (res: any) {
    localStorage.setItem('user', JSON.stringify(res.user))
    localStorage.setItem('token', res.token)

    const backUrl = localStorage.getItem('backUrl') || ''

    if (backUrl) {
        location.href = backUrl
    } else {
        location.href = '/' 
    }
}

export function logining(data: boolean) {
    return {
        type: 'LOGINING',
        data
    }
}

export function loginError(data: string) {
    return {
        type: 'LOGIN_ERROR',
        data
    }
}

export function login(data: object) {
    const url = 'rest-auth/login/'

    return (dispatch: any) => {
        dispatch(logining(true))

        ajax(url, data, 'POST').then(res => {
            if (res.hasError) {
                dispatch(loginError(res[Object.keys(res)[0]]))
            } else {
                dispatch(isLogin(true))
                afterLogin(res)
            }
            dispatch(logining(false))
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Auth/Login/actions.tsx